module.exports = "pegasus/assets/theme3/google-icon-1.png";